'use client';
import useEventCallback from '@mui/utils/useEventCallback';

export default useEventCallback;
